// extracted by mini-css-extract-plugin
module.exports = {"container":"Warning_container__pDwam","hidden":"Warning_hidden__1FNTo","icon":"Warning_icon__xnZFs","text":"Warning_text__39OEV"};